"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateActivityVisibleForCharacter = evaluateActivityVisibleForCharacter;
exports.filterRequiresCompletedForCharacter = filterRequiresCompletedForCharacter;
exports.filterRequiresActiveForCharacter = filterRequiresActiveForCharacter;
exports.evaluateActivityPlayable = evaluateActivityPlayable;
exports.evaluateActivityRequirementsMet = evaluateActivityRequirementsMet;
const openCharacterRuntime_1 = require("../utils/openCharacterRuntime");
function evaluateActivityVisibleForCharacter(def, characterName) {
    if (!def.eligibleCharacterNames || def.eligibleCharacterNames.length === 0) {
        return true;
    }
    return (0, openCharacterRuntime_1.characterMatchesEligibleList)(def.eligibleCharacterNames, characterName);
}
/**
 * Prerequisite activity ids from {@link ActivityDefinition.requiresCompleted} that apply to
 * {@code characterName}. Omits completed prerequisites that are only eligible for other characters
 * (e.g. a Woman-only lecture is not required on a Man's progress).
 */
function filterRequiresCompletedForCharacter(requiresCompleted, allActivities, characterName) {
    const byId = new Map(allActivities.map((a) => [a.id, a]));
    return requiresCompleted.filter((reqId) => {
        const prereq = byId.get(reqId);
        if (!prereq) {
            return true;
        }
        return evaluateActivityVisibleForCharacter(prereq, characterName);
    });
}
function filterRequiresActiveForCharacter(requiresActive, allActivities, characterName) {
    const byId = new Map(allActivities.map((a) => [a.id, a]));
    return requiresActive.filter((reqId) => {
        const prereq = byId.get(reqId);
        if (!prereq) {
            return true;
        }
        return evaluateActivityVisibleForCharacter(prereq, characterName);
    });
}
/**
 * Whether the activity can be started/continued (click enabled), ignoring visibility —
 * callers should combine with {@link evaluateActivityVisibleForCharacter} for full gating.
 */
function evaluateActivityPlayable(def, characterName, state, allActivities, evaluateRequiresScript) {
    if (!evaluateActivityVisibleForCharacter(def, characterName)) {
        return false;
    }
    if (state.completed.has(def.id)) {
        return false;
    }
    const relevantCompleted = filterRequiresCompletedForCharacter(def.requiresCompleted, allActivities, characterName);
    if (!relevantCompleted.every((id) => state.completed.has(id))) {
        return false;
    }
    const relevantActive = filterRequiresActiveForCharacter(def.requiresActive, allActivities, characterName);
    if (!relevantActive.every((id) => state.inProgress.has(id))) {
        return false;
    }
    if (def.requiresScript && def.requiresScript.trim()) {
        if (!evaluateRequiresScript) {
            return false;
        }
        return Boolean(evaluateRequiresScript(def.requiresScript));
    }
    return true;
}
/**
 * Whether prerequisite activities, active parents, and {@code Requires:} script (if any) are
 * satisfied for {@code characterName}. Unlike {@link evaluateActivityPlayable}, does not treat
 * the activity itself being completed as a failure.
 */
function evaluateActivityRequirementsMet(def, characterName, state, allActivities, evaluateRequiresScript) {
    if (!evaluateActivityVisibleForCharacter(def, characterName)) {
        return false;
    }
    const relevantCompleted = filterRequiresCompletedForCharacter(def.requiresCompleted, allActivities, characterName);
    if (!relevantCompleted.every((id) => state.completed.has(id))) {
        return false;
    }
    const relevantActive = filterRequiresActiveForCharacter(def.requiresActive, allActivities, characterName);
    if (!relevantActive.every((id) => state.inProgress.has(id))) {
        return false;
    }
    if (def.requiresScript && def.requiresScript.trim()) {
        if (!evaluateRequiresScript) {
            return false;
        }
        return Boolean(evaluateRequiresScript(def.requiresScript));
    }
    return true;
}
//# sourceMappingURL=evaluateActivityPlayable.js.map